export default "__VITE_ASSET__CSQzEPsQ__"